import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Box, Button, rem, Text } from '@bonusly/design-system';
import { useBuildRecognizeURL } from '@bonusly/url';

import { Route } from '../../../config/router';
import { HashtagTrend } from '../../../types/hashtag';
import { pathWithId } from '../../../utils/api';
import { cleanTag } from '../../../utils/hashtag';

interface HashtagDetailProps {
	hashtag: HashtagTrend;
}

export const HashtagDetail: FC<HashtagDetailProps> = ({ hashtag: { core_value, count, hashtag } }) => {
	const recognizeURL = useBuildRecognizeURL();
	const { t } = useTranslation('recognition');

	return (
		<Box>
			<Box mb={4}>
				<Text color="black" fontSize={rem(20)} fontWeight="medium">
					{hashtag}
				</Text>

				{!!count && (
					<Text color="gray.500" fontSize="sm" fontWeight="normal">
						{t('sidebar.trending.mentions_count', { count, context: 'full' })}
					</Text>
				)}
			</Box>

			{core_value && (
				<Text data-testid="core-value-description" color="gray.600" fontSize="md" mb={4} fontWeight="normal">
					{core_value.description}
				</Text>
			)}

			<Button as="a" href={recognizeURL(pathWithId(Route.Hashtags, cleanTag(hashtag)))} variant="alpha" w="full">
				{t('sidebar.trending.view_hashtag_button')}
			</Button>
		</Box>
	);
};
